'use client';

import { itemsPerQuery } from '@module/constants/pagenation';
import { useFetchLiveInfiniteQuery } from '@module/queries/live/liveQueryHooks';
import useModalStore from '@module/stores/useModalStore';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import { useIntersectionObserver } from '@module/utils/useIntersectionObserver';
import BroadcastUserItem from '@pc/components/list/broadcast/BroadcastUserItem';
import BroadcastUserList from '@pc/components/list/broadcast/BroadcastUserList';
import NotFoundDisplay from '@pc/components/result/NotFoundDisplay';
import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

function SearchLiveContainer() {
  const { pushModal } = useModalStore();
  const router = useRouter();
  const searchValue = useSearchParams().get('text');

  const { data, hasNextPage, fetchNextPage, error, isFetching } = useFetchLiveInfiniteQuery(
    {
      orderBy: 'user',
      searchVal: searchValue || '',
      limit: itemsPerQuery,
    },
    {
      enabled: !!searchValue,
      retry: false,
    },
  );

  const { observerRef } = useIntersectionObserver({
    isReadyToFetch: () => hasNextPage,
    onInView: fetchNextPage,
  });

  useEffect(() => {
    if (error instanceof BaseHttpResponseError) {
      pushModal({
        type: 'CONFIRM_MODAL',
        id: 'SearchLiveContainer',
        options: {
          description: error.message,
          onClose: () => router.back(),
        },
      });
    }
  }, [error]);

  return (
    <div className='flex justify-center' data-testid='search-live-page'>
      <div className='w-[1280px]'>
        <section className='mb-4 flex w-[1280px] items-center'>
          <div className='m-1 font-bold text-baseFg'>
            {`‘${searchValue || ''}’`} {'검색결과'}
          </div>
          <span className='text-[#ef312a]'>{data?.total || 0}</span>
          <span className='text-colorFg18'>{'개'}</span>
        </section>
        <section className='flex' data-testid='search-results'>
          <div className='min-h-[620px] flex-1'>
            {!!data?.pages && data.pages.length > 0 && (
              <BroadcastUserList>
                {data.pages.map((item) => {
                  return <BroadcastUserItem key={item.userIdx} item={item} />;
                })}
              </BroadcastUserList>
            )}

            {!isFetching && !data?.pages?.length && <NotFoundDisplay text={'검색결과가 없습니다.'} className='mt-10' />}
            <div className='h-1 w-full' ref={observerRef} />
          </div>
        </section>
      </div>
    </div>
  );
}

export default SearchLiveContainer;
